import type { AppState } from "../../types.ts";

export type ShellStatus = {
  status: string;
  phone: string;
  channelLabel: string;
};

export function deriveShellStatus(state: Pick<AppState, "accounts" | "whatsappSession">): ShellStatus {
  const accounts = state.accounts || [];
  const defaultSession = state.whatsappSession?.status === "connected" ? state.whatsappSession : null;
  const session =
    defaultSession ||
    accounts.find((account) => account.isDefault && (account as { status?: string }).status === "connected") ||
    accounts.find((account) => (account as { status?: string }).status === "connected") ||
    state.whatsappSession ||
    null;
  const status = session?.status || "absent";
  const sessionLike = session as { phone?: string; pushName?: string; label?: string; accountType?: string } | null;
  const rawPhone = sessionLike?.phone || "";
  const pushName = sessionLike?.pushName || "";
  const label = sessionLike?.label || "";
  const phone = rawPhone ? `+${rawPhone}` : numericAccountName(pushName) ? `+${pushName}` : pushName || label || "";
  const accountType = sessionLike?.accountType || "whatsapp";

  return {
    status,
    phone,
    channelLabel: channelLabelFor(accountType),
  };
}

function numericAccountName(value: string): boolean {
  return /^\d{10,15}$/.test(value);
}

function channelLabelFor(accountType: string): string {
  if (accountType === "instagram") return "Instagram";
  if (accountType === "linkedin") return "LinkedIn";
  if (accountType === "telegram") return "Telegram";
  return "WhatsApp";
}
